const Menu = () => {
  const header = document.querySelector(".header");
  const headerNav = document.querySelector(".header__nav");
  const opener = document.querySelector(".header__nav-opener");
  const activeClassName = "show-menu";

  if (!opener || !header || !headerNav) return;

  const classListOfBody = document.body.classList;

  opener.addEventListener("click", () => {
    classListOfBody.contains(activeClassName)
      ? classListOfBody.remove(activeClassName)
      : classListOfBody.add(activeClassName);
  });

  document.addEventListener("click", (e) => {
    const clickedOpener = e.target.closest(".header__nav-opener");
    if (
      !clickedOpener &&
      !headerNav.contains(e.target) &&
      classListOfBody.contains(activeClassName)
    ) {
      document.body.classList.remove(activeClassName);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.body.classList.remove(activeClassName);
    }
  });
};

export default Menu;
